import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { PositionItem } from '@easy-lib/modules/option/models/option.model';
import { calculateClosingPriceVarPercent } from '@easy-lib/tools/order-calc.tool';
import { getColorOfSymbolState } from '@easy-lib/tools/symbol-state.tool';
import * as orderSelector from '@easy-lib/state/orders/selectors/order.selector';

const getPositionState = (state: AppState) => state.positionState;

export const getPositionLoading = createSelector(getPositionState, state => state?.loading);
export const getPositions = createSelector(getPositionState, state => Object.values(state.entities));
export const getPositionIds = createSelector(getPositionState, state => state.ids as string[]);
export const getPositionIsins = createSelector(getPositions, positions => positions.map(t => t.symbolIsin));
export const getMarketData = createSelector(getPositionState, state => state.marketData);
export const getMarketDataIsins = createSelector(getMarketData, marketData => Object.keys(marketData));

export const getPositionsItems = createSelector(
	getPositions,
	getMarketData,
	orderSelector.getOpenBuyOrders,
	orderSelector.getOpenSellOrders,
	(positions, marketDatas, openBuyOrder, openSellOrder) => {
		return positions.map(position => {
			const marketData = marketDatas?.[position.symbolIsin];
			const openBuyQuantity =
				openBuyOrder[position.symbolIsin]?.map(t => t.quantity)?.reduce((a, b) => a + b, 0) ?? 0;
			const openSellQuantity =
				openSellOrder[position.symbolIsin]?.map(t => t.quantity)?.reduce((a, b) => a + b, 0) ?? 0;
			return {
				...position,
				...marketData,
				openBuyQuantity,
				openSellQuantity,
				stateColor: getColorOfSymbolState(marketData?.stateCode),
				closingPricePercent: calculateClosingPriceVarPercent(
					marketData?.closingPrice,
					marketData?.feeOfPreviousDaysClosingPrice,
					marketData?.totalNumberOfSharesTraded
				)
			} as Partial<PositionItem>;
		});
	}
);

export const getPositionsById = (id: string) => createSelector(getPositionState, state => state.entities[id]);
export const getPositionsByIsin = (symbolIsin: string) =>
	createSelector(getPositions, positions => positions?.find(t => t.symbolIsin === symbolIsin));
